"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const polished_1 = require("polished");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  z-index: ${({ $order }) => $order + 100};
  position: absolute;
  background: ${({ theme }) => theme.backgroundColor};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: ${(0, polished_1.rem)(325)};
`;
const PopupBody = styled_components_1.default.div `
  padding: ${(0, polished_1.rem)(20)};
  font-size: ${(0, polished_1.rem)(14)};
`;
const PopupFooter = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding: ${(0, polished_1.rem)(20)};
  border-top: ${(0, polished_1.rem)(1)} solid ${({ theme }) => theme.separatorColor};
  .sportnetui-btn {
    flex: 1 0 0;
  }
`;
class Popup extends React.Component {
    constructor() {
        super(...arguments);
        this.renderButton = (button) => {
            return React.cloneElement(button, {
                className: 'btn',
            });
        };
    }
    render() {
        const { text = '', order, buttons = [] } = this.props;
        return (React.createElement(exports.Wrapper, { "$order": order },
            React.createElement(PopupBody, null, text && React.createElement("div", null, text)),
            buttons && React.createElement(PopupFooter, null, buttons.map(this.renderButton))));
    }
}
exports.default = Popup;
